import { SelectOptions } from "@/components/selectOptions/selectOptions"

export const InstallationStatuses = {
  // use format of ====>    "DisplayName": "id",
  //
  "Installed": "installed",
  "Temp. Uninstalled": "tempUninstalled",
  "Fully Uninstalled": "uninstalled"
  }
  
export function InstallationStatusOptions(): SelectOptions {
  const out = [] as SelectOptions 
  for (const key in InstallationStatuses) {
    out.push({
      id: InstallationStatuses[key],
      value: InstallationStatuses[key],
      displayName: key
    })
  }
  return out
}